<template lang="pug" src="./hero-image.pug"></template>

<script>
export default {
  props: ['props'],
  methods: {
    scrolled ({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.$store.dispatch('VIEW_NAV', true)
      }
      if (going === this.$waypointMap.GOING_OUT) {
        this.$store.dispatch('VIEW_NAV', false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// hero-image.vue?7ce482e4